import { render } from "./email-ecommerce.vue?vue&type=template&id=bca3b048"
import script from "./email-ecommerce.vue?vue&type=script&lang=js"
export * from "./email-ecommerce.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__